import React from 'react';
import qs from 'query-string';
// import PropTypes from 'prop-types';
import { storage } from 'utils/usePersistState';
import FitContent from 'modules/common/FitContent';
import { getSessionByCode } from '../actions';

function SetSession() {
  const [error, setError] = React.useState(null);
  React.useEffect(() => {
    const query = qs.parse(window.location.search);
    if (!query.code) {
      setError({ message: 'Invalid URL' });
      return;
    }
    getSessionByCode(query.code, (session) => {
      // eslint-disable-next-line
      if (session?.error) {
        setError(session?.data);
        return;
      }
      storage.set('user-session', {
        partner_id: query.partner_id,
        token: session.token,
      });
      window.location.href = `/?partner_id=${query.partner_id}`;
    });
  }, [setError]);
  if (error) {
    return (
      <FitContent>
        <div className="m-auto">
          {error?.error_description || 'Error! Unable to create session...'}
        </div>
      </FitContent>
    );
  }
  return (
    <FitContent>
      <div className="m-auto">Please wait...</div>
    </FitContent>
  );
}

SetSession.propTypes = {};

export default SetSession;
